import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import withAddPayment from './withAddPayment';
import { closePayment } from '../reducer/currentPayment/actions';
import { getChargeAmount } from '../reducer/chargeAmount/selectors';
import { getPaymentCardIsSquirePay } from '../../../main/payment/selectors';
import { PAYMENT_TYPE } from '../../../main/payment/constants';

const withCardCharge = compose(
  withAddPayment,
  connect(
    state => ({
      chargeAmount: getChargeAmount(state),
      isSquirePay: getPaymentCardIsSquirePay(state),
    }),
    { closePayment }
  ),
  withHandlers({
    cardCharge: props => card => (
      props.addPayment({
        type: props.isSquirePay ? PAYMENT_TYPE.payfac : PAYMENT_TYPE.card,
        paymentToken: !card.id ? card.paymentToken : null,
        paymentCardId: card.id,
        amount: props.chargeAmount,
        cardInfo: { ...card },
      }).then(props.closePayment)
    ),
  }),

);

export default withCardCharge;
